import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstants } from 'src/app/core/endpointsAndGeneric-constants/api-constants';
import { HttpMethodModifierService } from 'src/app/core/http-method-modifier.service';
import { DeviceListPayloadModel, DeviceRealTimePayloadModelv1 } from 'src/app/core/model/devices/device-list';

@Injectable({
  providedIn: 'root'
})
export class DeviceManagementService {

  constructor(
    private httpGuard: HttpMethodModifierService

  ) { }

  createNDevices(noOfDevices: number): Observable<any> {
    const payload = {
      noOfDevices: Number(noOfDevices)
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.getCreateNDevices, payload);
  }

  getDevicePayload(deviceId: string): Observable<any> {
    const payload = {
      deviceId: deviceId
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.getdevicePayload, payload);
  }

  getDeviceRealTimeData(payload: DeviceRealTimePayloadModelv1[]) {

    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.getDeviceRealTimeData, payload);
  }

  listDevice(filter: DeviceListPayloadModel) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.listDevice, filter);
  }

  deleteDevice(_id: string): Observable<any> {
    return this.httpGuard.httpReq('delete', 'API_ENDPOINT', `${ApiConstants.URL.deleteDevice}/${_id}`, null);
  }

  /**
   * Creates devices
   * @param type 
   * @param payload 
   * @returns devices 
   */
  createDevices(type:string, payload: any): Observable<any> {
    let finalPayload: any = payload;
    if (type === 'csv' && payload instanceof File) {
      const fileFormData = new FormData();
      fileFormData.append('file', payload, payload.name);
      finalPayload = fileFormData;
    }
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', `${ApiConstants.URL.createDevicesV2}?type=${type}`, finalPayload);
  }
}
